<template>
  <div>
    <template v-if="account">
      <div>
        <h2 class="font-semibold">Connected SalesForce Organization:</h2>
        <p>
          "{{ account.name }}"
          <span
            v-if="account.sandbox"
            class="px-2 py-1 rounded-md bg-yellow-200 border border-1 border-yellow-500 text-xs"
            >SandBox</span
          >
        </p>
      </div>
      <div class="mt-8">
        <h2 class="font-semibold">How would you like to export attendees:</h2>
        <div class="mt-4">
          <CustomRadioButton
            name="exportType"
            value="contact"
            :model-value="selectedExportType"
            @change="onExportTypeChanged"
          >
            <span class="ml-4">As Contacts</span></CustomRadioButton
          >

          <CustomRadioButton
            class="mt-2"
            name="exportType"
            value="account"
            :model-value="selectedExportType"
            @change="onExportTypeChanged"
          >
            <span class="ml-4">As Accounts</span></CustomRadioButton
          >

          <CustomRadioButton
            class="mt-2"
            name="exportType"
            value="lead"
            :model-value="selectedExportType"
            @change="onExportTypeChanged"
          >
            <span class="ml-4">As Leads</span></CustomRadioButton
          >

          <CustomRadioButton
            class="mt-2"
            name="exportType"
            value="custom"
            :model-value="selectedExportType"
            @change="onExportTypeChanged"
          >
            <span class="ml-4">Custom Object</span></CustomRadioButton
          >

          <div v-if="showCustomObjectSelector" class="mt-6">
            <label class="font-semibold" for="selectedCustomObject"
              >Select Object</label
            >
            <div v-if="!customObjects" class="border p-3 bg-white rounded-lg">
              <Spinner :orange="true" class="mx-auto" />
            </div>

            <select
              v-else
              class="input mt-2"
              name="selectedCustomObject"
              v-model="selectedCustomObject"
            >
              <option
                v-for="(item, index) in customObjects"
                :key="index"
                :value="item.name"
                >{{ item.label }}</option
              >
            </select>
          </div>

          <!-- fields mapping -->
          <CustomObjectFieldsMapping
            @change="data => (fieldsMapping = data)"
            :existing-values="fieldsMapping"
            v-if="selectedCustomObject"
            :selected-custom-object="selectedCustomObject"
          />
        </div>
      </div>

      <div class="mt-12 flex">
        <LoadingButton
          class="btn btn-secondary py-3 px-12 font-semibold rounded-lg mr-2"
          @click="save()"
          :loading="saveBtnLoading"
          :spinnerOrange="true"
          >Save
        </LoadingButton>

        <LoadingButton
          @click="revokeSFToken"
          :loading="cancelBtnLoading"
          :spinnerOrange="true"
          class="btn btn-secondary py-3 px-12 font-semibold rounded-lg"
        >
          Cancel
        </LoadingButton>
      </div>
    </template>

    <!-- SalesForce authorization window -->
    <template v-else>
      <p class="mt-2 text-center text-sm">
        BuildaBox.co supports an integration to Salesforce.com to automatically
        create event attendees as Leads, Contacts or Accounts. Select the
        environment with which to integrate below, provide integration user
        credentials and the integration will be complete.
      </p>

      <div class="flex justify-center mt-8">
        <button
          class="btn btn-primary font-semibold rounded-lg px-4 block mr-4"
          @click="showSalesForceWindow('production')"
        >
          Production Log In
        </button>
        <button
          class="btn btn-primary font-semibold rounded-lg px-4 block"
          @click="showSalesForceWindow('sandbox')"
        >
          Sandbox Log in
        </button>
      </div>
    </template>
  </div>
</template>

<script>
import Api from "@/api/";
import ApiV1 from "@/api/api_v1.0";
import CustomRadioButton from "@/components/CustomRadioButton";
import LoadingButton from "../../../common/LoadingButton.vue";
import CustomDropDown from "@/components/common/controls/CustomDropDown";
import Spinner from "@/components/common/Spinner.vue";
import CustomObjectFieldsMapping from "@/components/order/integrations/salesforce/CustomFieldsMapping";

export default {
  name: "OrderSalesForceIntegrationComponent",
  props: ["order"],
  components: {
    CustomRadioButton,
    LoadingButton,
    CustomDropDown,
    Spinner,
    CustomObjectFieldsMapping
  },

  data() {
    return {
      saveBtnLoading: false,
      cancelBtnLoading: false,
      oauthUrl: null,
      account: null,
      selectedExportType: "",
      selectedCustomObject: null,
      customObjects: null,
      fieldsMapping: null
    };
  },

  async created() {
    await this.getSalesForceAccount();

    if (this.selectedExportType == "custom") {
      this.loadCustomObjects();
    }
  },

  computed: {
    user() {
      return this.$store.getters.personalDetails;
    },
    showCustomObjectSelector() {
      return this.selectedExportType == "custom";
    }
  },
  methods: {
    async showSalesForceWindow(mode) {
      // call api to get salesforce oauth url
      let response = await Api.getSalesForceOauthUrl({
        env: mode
      });

      this.oauthUrl = response.data;

      // store userid & orderid
      const sfd = {
        userid: this.user.id,
        orderid: this.order.id,
        env: mode
      };

      localStorage.setItem("sfoauthdata", JSON.stringify(sfd));

      const oauthWindow = window.open(
        this.oauthUrl,
        "_blank",
        `resizable,scrollbars,status, width=400, height=600, left=400 top=200`
      );

      this.timer = setInterval(() => {
        if (oauthWindow.closed) {
          const token = localStorage.getItem("access_token");
          const user = localStorage.getItem("user");
          clearInterval(this.timer);

          // update integration status
          this.getSalesForceAccount();
        }
      }, 500);
    },

    async getSalesForceAccount() {
      const response = await ApiV1.getOrderSFtoken(this.order.uuid);
      this.account = response.data;

      if (this.account) {
        const options = JSON.parse(response.data.pivot.options);
        this.selectedExportType = options?.exporttype;
        this.selectedCustomObject = options?.objectname;
        this.fieldsMapping = options?.fieldsmapping;
      }
    },

    async revokeSFToken() {
      this.cancelBtnLoading = true;

      const modal = await this.$swal({
        title: "Сonfirm cancellation of integration?",
        showCancelButton: true,
        confirmButtonText: "Yes",
        cancelButtonText: "No"
      });

      if (modal.isConfirmed) {
        await Api.revokeSFtoken(this.order.id);
        this.getSalesForceAccount();
        this.$emit("onRefreshAttendeesTable");
      }

      this.cancelBtnLoading = false;
    },

    onExportTypeChanged(type) {
      this.selectedExportType = type;

      if (type == "custom") {
        this.loadCustomObjects();
      }
    },

    async loadCustomObjects() {
      if (this.customObjects) {
        return false;
      }

      const response = await Api.getSalesforceCustomObjects();
      this.customObjects = response.data;
    },

    async save() {
      this.saveBtnLoading = true;

      await ApiV1.setOrderSFtokenOptions(this.order.uuid, {
        exporttype: this.selectedExportType,
        tokenid: this.account.id,
        objectname: this.selectedCustomObject,
        fieldsmapping: this.fieldsMapping
      });

      this.$emit("onRefreshAttendeesTable");

      this.showGlobalSuccessMessage("Configuration successfully saved!");

      this.saveBtnLoading = false;
    }
  }
};
</script>

<style></style>
